import { PropsWithChildren } from "react";
import { CountPill } from "react-migration/components/CountPill";
import { isDefined } from "react-migration/lib/util/isDefined";

type SubSectionHeaderProps = PropsWithChildren<{
  tooltip?: string;
  count?: number;
}>;

export function SubSectionHeader({ count, children }: SubSectionHeaderProps) {
  return (
    <div className="flex items-baseline gap-x-1">
      <h1 className="text-xs font-normal text-text-base-tertiary pt-1 pb-0">{children}</h1>
      {isDefined(count) && <CountPill count={count} />}
    </div>
  );
}
